var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-cell",class:{
    'table-cell__focus': _vm.inFocus
  }},[_vm._t("default",function(){return [_c('label',{staticClass:"content-wrapper"},[_c('Select',{staticClass:"select__borderless",attrs:{"value":_vm.value,"options":_vm.options},on:{"focus":function($event){_vm.inFocus = true},"blur":function($event){_vm.inFocus = false},"change":function($event){return _vm.$emit('change', $event)}}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }